// extracted by mini-css-extract-plugin
module.exports = {"footerOverviewEditor":"overviewEditor_footerOverviewEditor__3K6rJ"};